import React from "react";
import { SectionHeading } from "./SectionHeading";
import { bonuses } from "../../data/bonuses";
import { OFFER_HASH } from "../../data/links";
export function Bonuses() {
  return <section className="w-full bg-gold-light px-5 py-14 md:py-20" data-id="element-2" data-mp="259ggq99j0x0t">
      <div className="mx-auto max-w-5xl" data-id="element-3" data-mp="257n4meg59klf">
        <SectionHeading title={<>5 professional bonuses included <span className="text-green" data-id="element-5" data-mp="208iwzs8vbux7">free</span></>} data-id="element-4" data-mp="20b51tk4djwbq" />

        <div className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-6" data-mp="1vclgnlxluokf">
          {bonuses.map((b, i) => {
          const Icon = b.icon;
          return <article key={b.number} className={`flex h-full flex-col overflow-hidden rounded-xl bg-white shadow-[0_10px_24px_-18px_rgba(28,47,79,0.45)] ${i === bonuses.length - 1 ? "md:col-span-2" : ""}`} data-id="element-7" data-mp="1rcbao99tby5k" data-mpi={i}>
                <a href={OFFER_HASH} className="flex items-center gap-3 px-5 py-4 text-white" style={{
              backgroundColor: b.color
            }} data-id="element-8" data-mp="3gov8mymvoyp2">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white/15" data-id="element-9" data-mp="3bpilecs3hply">
                    <Icon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-10" data-mp="vtl6uwj9trk8" />
                  </span>
                  <div className="min-w-0 flex-1" data-id="element-11" data-mp="zwrbjzqqjaol">
                    <p className="inline-block rounded bg-gold px-1.5 py-0.5 font-display text-[10px] font-black uppercase text-navy" data-id="element-12" data-mp="lw6t54oqfgvm">Bonus {b.number}</p>
                    <h3 className="mt-1 font-display text-sm font-black uppercase leading-tight md:text-base" data-id="element-13" data-mp="qvtg45ud4bhm">{b.title}</h3>
                  </div>
                  <div className="shrink-0 text-right" data-id="element-14" data-mp="1jjyyilxy1oea">
                    <p className="text-xs font-semibold text-white/80 line-through" data-id="element-15" data-mp="1jjfkvhfbtm62">${b.value} USD</p>
                    <p className="font-display text-sm font-black uppercase text-gold" data-id="element-16" data-mp="14ussof4lozxf">Free</p>
                  </div>
                </a>
                <div className="flex flex-1 flex-col p-5" style={{
              backgroundColor: `${b.color}0A`
            }} data-id="element-17" data-mp="1xjq7u9dimgly">
                  <p className="text-sm text-navy/80" data-id="element-18" data-mp="22a6p64kgimdl">{b.description}</p>
                  <p className="mt-3 text-[11px] font-extrabold uppercase tracking-[0.15em] text-navy/60" data-id="element-19" data-mp="22cjg3787072s">{b.listTitle}</p>
                  <ul className="mt-1.5 flex flex-wrap gap-1.5" data-id="element-20" data-mp="277lt2gknoyr4">
                    {b.items.map(item => <li key={item} className="rounded-full border px-2.5 py-0.5 text-xs font-medium text-navy" style={{
                  borderColor: `${b.color}2E`,
                  backgroundColor: "#FFFFFF"
                }} data-id="element-21" data-mp="227pz7a5oanpa">
                        {item}
                      </li>)}
                  </ul>
                  <p className="mt-auto pt-4 font-display text-sm font-black uppercase" style={{
                color: b.color
              }} data-id="element-22" data-mp="1oh4fxkcb4bqv">{b.closing.join(" ")}</p>
                </div>
              </article>;
        })}
        </div>
      </div>
    </section>;
}